import { Text } from '@makemydeal/dr-ui-bricks-components';
import styled from 'styled-components';

export const OfferCommentsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    box-sizing: border-box;
    background-color: ${({ theme }) => theme.uiBricks?.pageBackgroundColor || '#ffffff'};
    border-radius: 8px;
    box-shadow: 0px 0px 12px 0px #00000033;
    padding: 20px;
`;

export const OfferCommentsHeading = styled(Text)`
    color: ${({ theme }) => theme.uiBricks?.headlineFontColor || '#000000'};
    padding: 5px 0;
`;

export const OfferCommentsMeta = styled(Text)`
    color: ${({ theme }) => theme.uiBricks?.secondaryFontColor || '#666666'};
`;

export const OfferCommentsText = styled(Text)`
    color: ${({ theme }) => theme.uiBricks?.primaryFontColor || '#000000'};
    background-color: #f5f5f5;
    border-radius: 4px;
    padding: 12px 16px;
    width: 100%;
    box-sizing: border-box;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
`;
